module.exports = __webpack_public_path__ + "ef10aa5780f13553c7f4951c74950cc6.MP3";